import { Card, CardContent, Typography } from '@mui/material'
import { FunctionComponent } from 'react'
import { Link } from 'react-router-dom'

export const ReportingEsrsCard: FunctionComponent<{ title: string, description: string, link: string }> = ({ title, description, link }) => {
  return (
    <Card component={Link} to={link} 
    sx={{
      mb: 2, height: '100%', boxShadow: 'none', borderWidth: '1px', borderStyle: 'solid', borderColor: 'lightGrey.main', borderRadius: '10px', textDecoration: 'none',
      '&:hover': {
        cursor: 'pointer',
      },
    }}>
      <CardContent sx={{ height: '100%', position: 'relative' }}>
        <Typography variant='subtitle1' sx={{ fontWeight: 600, color: 'text.primary' }}>
          {title}
        </Typography>
        <Typography variant='body2' sx={{ color: 'text.secondary', pb: 1 }}>
          {description}
        </Typography>
      </CardContent>
    </Card >
  )
}